module.exports = __webpack_public_path__ + "img/ndl_ideaproyectos.ee8b369a.png";